import {TruckLoad} from "./truck-load.model";
import {StatusHistoryModel} from "../status-history.model";
import {DocModel} from "../document/doc.model";
import {ReportModel} from "../report.model";


export class TruckLoadDetailModel {
  domesticDistributionOrderPack: TruckLoad;
  statusHistory: StatusHistoryModel[];
  docs: DocModel[];
  reports: ReportModel[];
}
